export default __webpack_public_path__ + "static/media/DownArrow.4cd1b784.svg";